import type { FaireProductEntity } from "../../entity_types/product";

export const p_t9s720w: FaireProductEntity = {
  token: "p_t9s720w",
  type: "product",
  name: "Flor de Madera Travel Spray",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/726f11f208052114bd4f131da5804a87c699e5044982bb0cc307906939cfcf66.webp",
  priceDollars: 22,
  description: "Flor de Madera perfume travel spray - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "fragrance", "bestseller", "travel-spray"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.1,
  dimensions: {
    width: 1.5,
    height: 4,
    depth: 1.5,
  },
  inStock: true,
};
